import { useMemo, useState } from "react";
import type {
  VillageIncidentChartCardData,
  VillageIncidentChartDatum,
  VillageIncidentChartMode,
} from "../model/villageIncidentCharts";

export type VillageChartConfigState = {
  chartMode: VillageIncidentChartMode;
  dimensionKey: string;
  data: VillageIncidentChartDatum[];
  setDimensionKey: (next: string) => void;
  toggleMode: () => void;
};

export function useVillageChartConfigState(card: VillageIncidentChartCardData): VillageChartConfigState {
  const [chartMode, setChartMode] = useState<VillageIncidentChartMode>("bar");
  const [dimensionKey, setDimensionKey] = useState(card.defaultDimensionKey);

  const resolvedDimensionKey = useMemo(() => {
    if (card.dataByDimension[dimensionKey]) {
      return dimensionKey;
    }

    return card.defaultDimensionKey;
  }, [card.dataByDimension, card.defaultDimensionKey, dimensionKey]);

  const data = useMemo(
    () => card.dataByDimension[resolvedDimensionKey] ?? [],
    [card.dataByDimension, resolvedDimensionKey],
  );

  function toggleMode() {
    setChartMode((current) => (current === "bar" ? "pie" : "bar"));
  }

  return {
    chartMode,
    dimensionKey: resolvedDimensionKey,
    data,
    setDimensionKey,
    toggleMode,
  };
}
